import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import { colors } from '../../../../../styles/constants'

const CARD_BOX_SIZES = {
  title: {
    width: '190px',
    height: '20px',
    borderRadius: '8px',
    marginBottom: '4px'
  },
  subtitle: {
    width: '290px',
    height: '20px',
    borderRadius: '8px',
    marginBottom: '24px'
  },
  card: {
    width: '100%',
    height: '72px',
    borderRadius: '12px',
    marginBottom: '16px'
  }
}

export const SkeletonCard = styled(Skeleton)`
  width: ${({ type }) => CARD_BOX_SIZES[type].width ?? 'inherit'};
  height: ${({ type }) => CARD_BOX_SIZES[type].height ?? 'inherit'};
  border-radius: ${({ type }) => CARD_BOX_SIZES[type].borderRadius ?? '0'};
  margin-bottom: ${({ type }) => CARD_BOX_SIZES[type].marginBottom ?? '0'};
`

export const Container = styled.div`
  margin: 0 16px 24px 16px;
  span {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  text-align: center;
  color: ${colors.gray.dark};
  margin-bottom: 4px;
`

export const Subtitle = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  margin-bottom: 24px;
  color: ${colors.gray.dark};
`
